import React ,{Component} from 'react';
import TooManyOOBCodesPage from '../../pages/accountLinking/tooManyOOBCodes'

class TooManyOOBCodes extends Component{

    render(){

        return(

            <div className="Rectangle-100">

            <TooManyOOBCodesPage/>

            </div>

            );
    }
}

export default TooManyOOBCodes